( function () {
    'use strict';
    jQuery.extend( true, e4.settings, {
        nav: {
            flagCDN: 'https://cdn.jsdelivr.net/npm/flag-icon-css@2.8.0/flags/4x3/'
        },
        search: {
            result: {
                products: {
                    showAllLink: '/quote/search?q=',
                    max: {
                        xs: 2,
                        sm: 2,
                        md: 4,
                        lg: 4,
                        xl: 4
                    }
                },
                files: {
                    show: true,
                    url: '/system/data/files?q='
                }
            }
        },
        ecom: {
            checkout: {
                termsAndConditions: ''
            }
        }
    } );
}() );

